import React from "react";
import Accordion, { Item as AccordionItem } from "devextreme-react/accordion";
import DataGrid, { Column } from "devextreme-react/data-grid";
import PieChart, {
  Legend,
  Export,
  Series,
  Label,
  Font,
  Connector,
} from "devextreme-react/pie-chart";

class Graficos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.tipoIptuDatasource = [
      { bairro: "Centro", territorial: 20, predial: 40, total: 60 },
      { bairro: "Beleza", territorial: 30, predial: 10, total: 40 },
    ];

    this.possuiCpfDatasource = [
      { bairro: "Centro", comCpf: 50, semCpf: 10, total: 60 },
      { bairro: "Beleza", comCpf: 10, semCpf: 30, total: 40 },
    ];

    this.possuiCpfDatasourceGrafico = [
      { argumento: "Com CPF", total: 60 },
      { argumento: "Sem CPF", total: 40 },
    ];

    this.customizeText = this.customizeText.bind(this);
  }

  customizeText(e) {
    return `${e.argumentText} (${e.percentText})`;
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <div id="accordion">
          <Accordion collapsible={true} multiple={true} animationDuration={300}>
            <AccordionItem title="Bairro - Tipo de IPTU">
              <DataGrid
                dataSource={this.tipoIptuDatasource}
                keyExpr="bairro"
                showBorders={true}
              />
              <PieChart
                id="pie"
                palette="Bright"
                dataSource={this.tipoIptuDatasource}
                title="Tipo de IPTU"
              >
                <Export enabled={true} />
                <Series argumentField="bairro" valueField="total">
                  <Label
                    visible={true}
                    position="columns"
                    customizeText={this.customizeText}
                  >
                    <Font size={16} />
                    <Connector visible={true} width={0.5} />
                  </Label>
                </Series>
              </PieChart>
            </AccordionItem>
            <AccordionItem title="Bairro - Possui CPF">
              <DataGrid
                dataSource={this.possuiCpfDatasource}
                keyExpr="bairro"
                showBorders={true}
              >
                <Column dataField={"bairro"} caption={"Bairro"} />
                <Column dataField={"comCpf"} caption={"Com CPF"} />
                <Column dataField={"comCpf"} caption={"Sem CPF"} />
                <Column dataField={"total"} caption={"Total"} />
              </DataGrid>
              <PieChart
                id="pie"
                palette="Bright"
                dataSource={this.possuiCpfDatasourceGrafico}
                title="Possui CPF"
              >
                <Export enabled={true} />
                <Series argumentField="argumento" valueField="total">
                  <Label
                    visible={true}
                    position="columns"
                    customizeText={this.customizeText}
                  >
                    <Font size={16} />
                    <Connector visible={true} width={0.5} />
                  </Label>
                </Series>
              </PieChart>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    );
  }
}

export default Graficos;
